/**
 * WHO is asking. The Clerk seam.
 *
 *   TODAY      every policy's `requires` map is empty, and the app constructs
 *              only UNRESTRICTED_ACTOR. The gate below runs on every decide()
 *              and always passes.
 *
 *   WHEN CLERK per-policy, per-action lists are filled in, e.g.
 *   LANDS        requires: { view: ['salesOrder:view'], perform: { cancel: ['salesOrder:cancel'] } }
 *              and the web and api bindings (neither exists yet) construct a
 *              real Actor from the session claims. NO rule body, NO consumer,
 *              and NO signature changes.
 *              The LaunchDarkly permissionsCan* deny-lists and the hardcoded
 *              Dawsons user id (web/src/auth.tsx:300-303) retire into these
 *              lists — see Follow-on Work ⑧–⑨.
 */
export type Actor = {
  /** `'*'` means unrestricted. Becomes a concrete claim list when Clerk lands. */
  permissions: readonly string[] | '*';
};

/**
 * The only Actor the application constructs today. Deliberately a value, not a
 * default parameter — grep for it to find every place Clerk has to reach.
 */
export const UNRESTRICTED_ACTOR: Actor = { permissions: '*' };

/** Stage ① of the kernel. Live today, empty today. */
export const actorSatisfies = (actor: Actor, required: readonly string[]): boolean => {
  if (required.length === 0) return true;
  if (actor.permissions === '*') return true;
  return required.every((permission) => actor.permissions.includes(permission));
};
